// extracted by mini-css-extract-plugin
module.exports = {"container":"TitledSectionStyles_container__K1YQc","header":"TitledSectionStyles_header__CZNWR","title":"TitledSectionStyles_title__1DC3-"};